import { render, staticRenderFns } from "./Zshc.vue?vue&type=template&id=62aac483&scoped=true&"
import script from "./Zshc.vue?vue&type=script&lang=js&"
export * from "./Zshc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aac483",
  null
  
)

export default component.exports